import { useState } from 'react';

import { SuggestInput } from '../../components/SuggestInput';
import { useDebounced } from '../../lib/useDebounced';
import type { SuggestionField } from './api';
import { useValueSuggestions } from './queries';

interface CrmSuggestInputProps {
  id?: string;
  field: SuggestionField;
  value: string;
  onChange: (value: string) => void;
  normalize?: (value: string) => string;
}

/**
 * Ein CRM-Freitextfeld mit Vorschlaegen aus dem Bestand -- Branche, Funktion,
 * Ort, Land. Gefragt wird erst, wenn jemand das Feld oeffnet.
 */
export function CrmSuggestInput({ id, field, value, onChange, normalize }: CrmSuggestInputProps) {
  const [term, setTerm] = useState('');
  const [opened, setOpened] = useState(false);
  const suggestions = useValueSuggestions(field, useDebounced(term), opened);

  return (
    <SuggestInput
      id={id}
      value={value}
      onChange={onChange}
      normalize={normalize}
      suggestions={suggestions.data ?? []}
      loading={suggestions.isFetching}
      onSearch={(next) => {
        setOpened(true);
        setTerm(next);
      }}
    />
  );
}
